import React from "react";
import { graphql } from "gatsby";

import Layout from "components/Layout";
import SEO, { createQueryImageFromFile } from "components/SEO";

import { SectionsPageTemplate } from "./innerTemplates/SectionsPageTemplate";

const DATE_PUBLISHED = new Date("2019-08-12T12:51:31+00:00");

export const pageQuery = graphql`
  fragment SectionData on MarkdownRemarkFrontmatterSections {
    ...SectionFeatureData
    ...SectionClientCasesData
    ...SectionTestimonialsData
    ...SectionLogoRowData
    ...SectionCTAData
    ...SectionContentData
    ...SectionHeroData
    ...SectionLeadershipData
    ...SectionContentCardsData
    ...SectionCollapsibleData
    ...SectionEbooksData
    ...SectionPricingCardsData
    ...SectionPricingFeatureTableData
    section_id
    type
  }

  query SectionsPageQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      fields {
        dateModified
      }
      frontmatter {
        title
        description
        sharingImage {
          image {
            ...OpenGraphImage
            ...TwitterImage
            ...StructuredDataImage
          }
          alt
          caption
        }
        sections {
          ...SectionData
        }
      }
    }
  }
`;

export default function SectionsPage({
  location: { pathname },
  data: {
    markdownRemark: {
      frontmatter: { title: pageTitle, description, sharingImage, sections },
      fields: { dateModified },
    },
  },
}) {
  const [openGraph, twitter, sdPrimaryImage] = createQueryImageFromFile(
    sharingImage,
    ["openGraphImage.resize", "twitterImage.resize", "sdImage.resize"]
  );

  return (
    <Layout gradientBackground>
      <SEO
        pathname={pathname}
        title={pageTitle}
        description={description}
        images={{ openGraph, twitter, sdPrimaryImage }}
        datePublished={DATE_PUBLISHED}
        dateModified={new Date(dateModified)}
      />
      <SectionsPageTemplate sections={sections} />
    </Layout>
  );
}
